export default __webpack_public_path__ + "static/media/pfotenphysioIntro.48fe0eeb.webm";